import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import BadgeIcon from "@mui/icons-material/Badge";
import AddCardIcon from "@mui/icons-material/AddCard";
import banner1 from "../../../assets/images/ocean.jpg";
// import Container from "../../../common/Container";

const cardStyle = {
  bgcolor: "rgba(0, 0, 0, 0)",
  color: "#fff",
  border: "0.2px solid #aaa",
  "&:hover": {
    bgcolor: "#00AEEF",
    color: "#fff",
  },
};

const objectList = [
  {
    icon: (
      <AgricultureIcon
        fontSize="large"
        sx={{
          color: "#fff",
          width: 52,
          height: 52,
          "&:hover": { color: "#9DCC49" },
        }}
      />
    ),
    title: "Sustainable Aquaculture and Fisheries Management and Zero Hunger",
    subtitle:
      "AHAN is dedicated to sustainable aquaculture and fisheries to combat hunger in Africa. We have a belief that Africa ought to feed the world and Nigeria must take the lead in this regard.",
  },
  {
    icon: (
      <BadgeIcon
        fontSize="large"
        sx={{
          color: "#fff",
          width: 52,
          height: 52,
          "&:hover": { color: "#9DCC49" },
        }}
      />
    ),
    title: "Employment Generation",
    subtitle:
      "AHAN uses aqauculture and fisheries as a tool to create jobs and reduce unemployment in Nigeria and Africa.",
  },
  {
    icon: (
      <AllInclusiveIcon
        fontSize="large"
        sx={{
          color: "#fff",
          width: 52,
          height: 52,
          "&:hover": { color: "#9DCC49" },
        }}
      />
    ),
    title: "Diversity, Inclusion and Skill Gap",
    subtitle:
      "AHAN promotes aquaculture and fisheries diversity and social inclusion to bridge skill gaps. This is piloted by its foundation – Blue-Echo Foundation.",
  },
  {
    icon: (
      <EmojiObjectsIcon
        fontSize="large"
        sx={{
          color: "#fff",
          width: 52,
          height: 52,
          "&:hover": { color: "#9DCC49" },
        }}
      />
    ),
    title: "Technology, Innovation and Research",
    subtitle:
      "AHAN's continuous research and innovative solutions address challenges in the African aquaculture and fisheries sector. This is evident in some consultancy and value chain development jobs we have undertaken.",
  },
  {
    icon: (
      <AddCardIcon
        fontSize="large"
        sx={{
          color: "#fff",
          width: 52,
          height: 52,
          "&:hover": { color: "#9DCC49" },
        }}
      />
    ),
    title: "Livelihood Improvement",
    subtitle:
      "AHAN's value chain approach contributes to livelihood improvement.",
  },
];

const Goals = () => {
  return (
    <Box marginTop={{ xs: "35%", sm: "10%" }}>
      <Box position={"relative"}>
        <Box
          component="img"
          height={{ xs: "230vh", sm: "750px" }}
          display={{ xs: "none", sm: "inline" }}
          sx={{
            objectFit: "cover",
            position: "relative",
            overflow: "hidden",
            width: "100%",
          }}
          src={banner1}
          alt={"goals_image"}
        />
        <Box>
          <Box
            paddingBottom={"3%"}
            position={"absolute"}
            top={{ xs: "5%", sm: "17%" }}
            width={{ xs: "90%", sm: "100%" }}
          >
            <Typography
              variant="h3"
              color="#fff"
              fontWeight={900}
              paddingBottom={"2%"}
              paddingTop={{ xs: "25%", sm: "0%" }}
              paddingLeft={{ xs: "4%", sm: "0.5%" }}
              textAlign={"left"}
            >
              Our Goals
            </Typography>
            <Grid container spacing={1}>
              {objectList.map((list, index) => {
                const { title, icon, subtitle } = list;
                return (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={2.2}
                      paddingBottom={{ xs: "4%", sm: "0%" }}
                      marginLeft={{ xs: "4%", sm: "1%" }}
                    >
                      <Box
                        key={index}
                        component={Card}
                        height={"100%"}
                        padding={{ xs: "2% 4%", sm: "6% 8%" }}
                        display={"flex"}
                        flexDirection={"column"}
                        width={{ xs: "100%", sm: "100%" }}
                        margin={{ xs: "2% 0%", sm: "2% 0%" }}
                        data-aos={"fade-down"}
                        sx={{ ...cardStyle }}
                      >
                        <Box marginLeft={"2%"}>{icon}</Box>
                        <Typography
                          variant={"h5"}
                          fontWeight={700}
                          paddingTop={{ xs: "4%", sm: "6%" }}
                        >
                          {title}
                        </Typography>
                        <Typography
                          variant={"body1"}
                          paddingTop={{ xs: "4%", sm: "8%" }}
                        >
                          {subtitle}
                        </Typography>
                      </Box>
                    </Grid>
                  </>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Goals;
